import Vue from "vue";
import Router from "vue-router";
import AppHeader from "./layout/AppHeader";
import AppFooter from "./layout/AppFooter";
import Index from "./views/Index.vue";

Vue.use(Router);

export default new Router({
  linkExactActiveClass: "active",
  mode: 'history',
  routes: [
    {
      path: "/",
      name: "index",
      components: {
        header: AppHeader,
        default: Index,
        footer: AppFooter
      },
      meta: {
        title: '傲卓集團科技有限公司',
        icon:"favicon.png",
        metaTags: [
          {
            name: 'description',
            content: '傲卓集團科技有限公司乃傲卓集團有限公司旗下的研發及開拓純天然產品的子公司，致力研發及引入各地以純天然成分的產品作為在香港或以外地方推廣'
          }
        ]
      }
    }
  ],
  scrollBehavior: to => {
    if (to.hash) {
      return { selector: to.hash };
    } else {
      return { x: 0, y: 0 };
    }
  }
});
